import { setCookie } from '@/utils/cookies';

const COOKIE_NAMES = {
  GCLID: 'SP-GCLID',
  AD_GROUP_ID: 'SP-AD_GROUP_ID',
  AFFILIATES: 'SP-AFFILIATES',
  REFERRER: 'SP-REFERRER',
  IMPACT_CLICK_ID: 'SP-IMPACT_CLICK_ID',
  IMPACT_PARTNER_ID: 'SP_IMPACT_PARTNER_ID',
  IMPACT_CREATED_AT: 'SP_IMPACT_CREATED_AT',
  IMPACT_MEDIUM: 'SP_IMPACT_MEDIUM',
};

export const setAdGroupIdCookie = (searchParams: URLSearchParams) => {
  const adGroupId = searchParams.get('adgroupid');
  if (!adGroupId) return;
  setCookie({ name: COOKIE_NAMES.AD_GROUP_ID, value: adGroupId, days: 90 });
};

export const setAffiliatesCookie = (searchParams: URLSearchParams) => {
  if (searchParams.size === 0) return;
  setCookie({
    name: COOKIE_NAMES.AFFILIATES,
    value: window.location.href,
    days: 60,
  });
};

export const setGoogleClickIdCookie = (searchParams: URLSearchParams) => {
  const gclid = searchParams.get('gclid');
  if (!gclid) return;
  setCookie({ name: COOKIE_NAMES.GCLID, value: gclid, days: 90 });
};

export const setPartnerizeCookies = (searchParams: URLSearchParams) => {
  const clickRef = searchParams.get('x-clickref');
  if (!clickRef) return;
  setCookie({
    name: 'cb_prf_sp',
    value: clickRef,
    days: 60,
  });
};

export const setupImpactCookies = (searchParams: URLSearchParams) => {
  const irclickid = searchParams.get('irclickid');
  if (!irclickid) return;
  setCookie({
    name: COOKIE_NAMES.IMPACT_CLICK_ID,
    value: irclickid,
    days: 90,
  });

  const createdat = new Date().toUTCString();
  setCookie({
    name: COOKIE_NAMES.IMPACT_CREATED_AT,
    value: createdat,
    days: 90,
  });

  const mediapartnerid = searchParams.get('mediapartnerid');
  if (mediapartnerid) {
    setCookie({
      name: COOKIE_NAMES.IMPACT_PARTNER_ID,
      value: mediapartnerid,
      days: 90,
    });
  }

  const medium = searchParams.get('medium');
  if (medium) {
    setCookie({
      name: COOKIE_NAMES.IMPACT_MEDIUM,
      value: medium,
      days: 90,
    });
  }
};

export const setReferrerCookie = () => {
  if (document.referrer) {
    setCookie({
      name: COOKIE_NAMES.REFERRER,
      value: document.referrer,
      days: 60,
    });
  }
};

export const setCookiesFromSearchParams = (searchParams: URLSearchParams) => {
  const params = ['coupon'];
  params.forEach((param) => {
    const value = searchParams.get(param);
    if (value) {
      setCookie({ name: `decodo_${param}`, value, days: 30 });
    }
  });
};
